import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=2dd76e90&scoped=true&"
import script from "./Window.vue?vue&type=script&lang=js&"
export * from "./Window.vue?vue&type=script&lang=js&"
import style0 from "./Window.vue?vue&type=style&index=0&id=2dd76e90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd76e90",
  null
  
)

export default component.exports